import { NgModule } from '@angular/core';

import { Routes, RouterModule } from '@angular/router';
import { FinalizeComponent } from './shared/components/finalize/finalize.component';
import { SupprotChatBoxModule } from './supprot-chat/supprot-chat-box.module';
import { SupportFormModule } from './support-form/support-form.module';
import { LoginModule } from './shared/components/login/login.module';
import { ChatComponent } from './supprot-chat/chat/chat.component';
import { FormComponent } from './support-form/form/form.component';
import { LoginComponent } from './shared/components/login/login.component';
import { MainComponent } from './main/main.component';
import { MainModule } from './main/main.module';
import { SignPageComponent } from './sign-page/sign-page.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full'},
  {
    path: 'thank-you-page',
    component: SignPageComponent,
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'support',
    component: MainComponent,
    loadChildren: () => import('./main/main.module').then(m => m.MainModule),
  },
  {
    path: '**',
    redirectTo: '404', pathMatch: 'full'
  },
  {
    path: '404',
    component: FinalizeComponent,
  },
  
];


//CreateQuoteModule

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {enableTracing: false}),
    SupprotChatBoxModule,
    SupportFormModule,
    MainModule,
    LoginModule
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
